"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BC_LOCATION_BUILDER_Y = exports.BC_LOCATION_BUILDER_X = exports.BC_LOCATION_BUILDER_HEIGHT = exports.BC_LOCATION_BUILDER_WIDTH = exports.BC_LOCATION_BUILDER_CENTER_POSITION = exports.BC_LOCATION_BUILDER_START_POSITION = exports.BC_LOCATION_BUILDER_END_POSITION = exports.BC_LOCATION_BUILDER_NUMBER_6 = exports.BC_LOCATION_BUILDER_ARROW_SPACE = exports.BC_LOCATION_BUILDER_NUMBER_2 = exports.BC_LOCATION_BUILDER_BOTTOM = exports.BC_LOCATION_BUILDER_TOP = exports.BC_LOCATION_BUILDER_LEFT = exports.BC_LOCATION_BUILDER__RIGHT = exports.BC_LOCATION_BUILDER_ANIMATION_IN = void 0;
exports.BC_LOCATION_BUILDER_ANIMATION_IN = "fade-in-opacity ease-in-out 350ms forwards";
exports.BC_LOCATION_BUILDER__RIGHT = "right";
exports.BC_LOCATION_BUILDER_LEFT = "left";
exports.BC_LOCATION_BUILDER_TOP = "top";
exports.BC_LOCATION_BUILDER_BOTTOM = "bottom";
exports.BC_LOCATION_BUILDER_NUMBER_2 = 2;
exports.BC_LOCATION_BUILDER_ARROW_SPACE = 16;
exports.BC_LOCATION_BUILDER_NUMBER_6 = 6;
exports.BC_LOCATION_BUILDER_END_POSITION = 'end';
exports.BC_LOCATION_BUILDER_START_POSITION = 'start';
exports.BC_LOCATION_BUILDER_CENTER_POSITION = 'center';
exports.BC_LOCATION_BUILDER_WIDTH = 'width';
exports.BC_LOCATION_BUILDER_HEIGHT = 'height';
exports.BC_LOCATION_BUILDER_X = 'x';
exports.BC_LOCATION_BUILDER_Y = 'y';
